/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookFilePayloadItemModel from './BookFilePayloadItemModel';

/**
 * The BookFilePayloadModel model module.
 * @module model/BookFilePayloadModel
 * @version v1.0.0
 */
class BookFilePayloadModel {
    /**
     * Constructs a new <code>BookFilePayloadModel</code>.
     * @alias module:model/BookFilePayloadModel
     */
    constructor() { 
        
        BookFilePayloadModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookFilePayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookFilePayloadModel} obj Optional instance to populate.
     * @return {module:model/BookFilePayloadModel} The populated <code>BookFilePayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookFilePayloadModel();

            if (data.hasOwnProperty('audioBook')) {
                obj['audioBook'] = ApiClient.convertToType(data['audioBook'], [BookFilePayloadItemModel]);
            }
            if (data.hasOwnProperty('cover')) {
                obj['cover'] = ApiClient.convertToType(data['cover'], [BookFilePayloadItemModel]);
            }
            if (data.hasOwnProperty('epubPreview')) {
                obj['epubPreview'] = ApiClient.convertToType(data['epubPreview'], [BookFilePayloadItemModel]);
            }
            if (data.hasOwnProperty('epubProd')) {
                obj['epubProd'] = ApiClient.convertToType(data['epubProd'], [BookFilePayloadItemModel]);
            }
            if (data.hasOwnProperty('multimedia')) {
                obj['multimedia'] = ApiClient.convertToType(data['multimedia'], [BookFilePayloadItemModel]);
            }
            if (data.hasOwnProperty('thumb')) {
                obj['thumb'] = ApiClient.convertToType(data['thumb'], [BookFilePayloadItemModel]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/BookFilePayloadItemModel>} audioBook
 */
BookFilePayloadModel.prototype['audioBook'] = undefined;

/**
 * @member {Array.<module:model/BookFilePayloadItemModel>} cover
 */
BookFilePayloadModel.prototype['cover'] = undefined;

/**
 * @member {Array.<module:model/BookFilePayloadItemModel>} epubPreview
 */
BookFilePayloadModel.prototype['epubPreview'] = undefined;

/**
 * @member {Array.<module:model/BookFilePayloadItemModel>} epubProd
 */
BookFilePayloadModel.prototype['epubProd'] = undefined;

/**
 * @member {Array.<module:model/BookFilePayloadItemModel>} multimedia
 */
BookFilePayloadModel.prototype['multimedia'] = undefined;

/**
 * @member {Array.<module:model/BookFilePayloadItemModel>} thumb
 */
BookFilePayloadModel.prototype['thumb'] = undefined;






export default BookFilePayloadModel;

